import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { OccEndpointsService, UserIdService } from '@spartacus/core'
import { Observable, of } from 'rxjs'
import { catchError, map, switchMap, take } from 'rxjs/operators'
import { EbAvailability, EbAvailabilityItem } from '../../interfaces/eb-availability.interface'

@Injectable()
export class EbAvailabilityAdapter {
  constructor(
    private readonly http: HttpClient,
    private readonly occEndpoints: OccEndpointsService,
    private readonly userIdService: UserIdService
  ) {}

  fetchAvailabilities(
    availabilities: EbAvailabilityItem[],
    invalidateCache = false,
    shippingDate?: string
  ): Observable<EbAvailability> {
    return this.userIdService.getUserId().pipe(
      take(1),
      map(userId =>
        this.occEndpoints.buildUrl('availability', {
          urlParams: {
            userId
          },
          queryParams: { invalidateCache, shippingDate }
        })
      ),
      switchMap(url => this.http.post<EbAvailability>(url, availabilities)),
      catchError(error => of({ error } as EbAvailability))
    )
  }

  setEarliestShippingDate(availabilities: EbAvailabilityItem[]): Observable<any> {
    return this.userIdService.getUserId().pipe(
      take(1),
      map(userId =>
        this.occEndpoints.buildUrl('earliestShippingDate', {
          urlParams: {
            userId
          }
        })
      ),
      switchMap(url => this.http.post<EbAvailability>(url, availabilities)),
      catchError(error => of({ error } as EbAvailability))
    )
  }
}
